import { baseUrl } from '@constants/baseUrl';
import { authHeader } from '../constants/authenticationHeader';

export const unarchiveJob = (jobId) => {
  // Use the update endpoint to properly unarchive the job
  return fetch(`${baseUrl}/rest/jobs/update`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader().common,
    },
    body: JSON.stringify({ 
      id: jobId, 
      archived: 0,       // Set archived to 0 (not archived)
      job_status: 1,     // Set status to active
      expired: 0         // Also ensure not expired
    }),
  })
    .then((res) => {
      if (res.ok) {
        return res.json().then((data) => {
          return { success: true, data };
        });
      } else {
        return res.json().then((errorData) => {
          return { 
            success: false, 
            message: errorData.message || 'Failed to restore job' 
          };
        }).catch(() => {
          return { success: false, message: 'Failed to restore job' };
        });
      }
    })
    .catch((err) => {
      return { success: false, message: 'Error occurred while restoring the job' };
    });
};
